export default __webpack_public_path__ + "static/media/news73.a727c5f2.jpg";